import { render, staticRenderFns } from "./OccurrenceRegistry.vue?vue&type=template&id=735b33b8&"
import script from "./OccurrenceRegistry.vue?vue&type=script&lang=js&"
export * from "./OccurrenceRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports